import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {BreakdownFilter} from '../models/filters/breakdown-filters';
import {BreakdownDTO} from '../models/breakdown';
import { getFileNameFromResponseContentDisposition, checkIfTruncated, saveFile } from './utils/file-download-helper';


@Injectable()
export class BreakdownService {

  BKD_API_URL: string = environment.serverUrl + 'api/1/breakdowns';

  constructor(private httpClient: HttpClient) {
  }

  getBreakdown(breakdownId: number): Observable<any> {
    return this.httpClient.get<any>(`${this.BKD_API_URL}/${breakdownId}`);
  }

  getFormattedUrl(pageIndex: number, itemPerPage: number,
    filters: BreakdownFilter, criterias: Map<string, boolean>) {
    const offset = ((pageIndex - 1) * itemPerPage); // records offset to display the specific range

    let url = this.BKD_API_URL + '?pagination=' + offset + '-' + itemPerPage + '&sorts=';

    if (criterias.size === 0) { // if no sorts criterias => sort by creation Date desc
      url += 'bkdCreationDate desc';
    } else {
      Array.from(criterias.keys()).forEach(c => url += c + (criterias.get(c) === true ? ' asc' : ' desc') + ',');
      url = url.substring(0, url.length - 1);
    }

    if (filters !== undefined) {

      const filtersAsString = JSON.stringify(filters, (key, value) => {
        if (value !== null && value !== undefined && value !== '') {
          return value;
        }
      });

      if (filtersAsString.length > 2) {
        url += '&filters=' + filtersAsString;
      }
    }
    return url;
  }

  getPaginatedFilteredSortedAccountsList(pageIndex: number, itemPerPage: number,
                                         filters: BreakdownFilter, criterias: Map<string, boolean>): any {
   
    let url = this.getFormattedUrl(pageIndex, itemPerPage, filters, criterias);
    return this.httpClient.get<any>(encodeURI(url), {observe: 'response'}).map(response => {
        return {
          headers: response.headers,
          res: <BreakdownDTO[]>response.body
        };
      }
    );
  }

  downloadXLSFile(pageIndex: number, itemPerPage: number, filters: BreakdownFilter, criterias: Map<string, boolean>): any {
    let url = this.getFormattedUrl(pageIndex, itemPerPage, filters, criterias);
    return this.httpClient.get<any>(encodeURI(url), {
      headers: { Accept: 'application/octet-stream' },
      responseType: 'blob' as 'json',
      observe: 'response'
    }).map((response) => {
      const fileName = getFileNameFromResponseContentDisposition(response, "breakdowns.xls");
      const isTruncated = checkIfTruncated(response);
      saveFile(response.body.slice(), fileName);
      return isTruncated;
    });
  }

  create(breakdown: BreakdownDTO): Observable<BreakdownDTO> {
    return this.httpClient.post<BreakdownDTO>(this.BKD_API_URL, breakdown);
  }

  update(breakdown: BreakdownDTO): Observable<BreakdownDTO> {
    return this.httpClient.put<BreakdownDTO>(`${this.BKD_API_URL}/${breakdown.id}`, breakdown);
  }

  patch(breakdown: BreakdownDTO): Observable<BreakdownDTO> {
    return this.httpClient.patch<BreakdownDTO>(`${this.BKD_API_URL}/${breakdown.id}`, breakdown);
  }

  delete(breakdown: BreakdownDTO): Observable<void> {
    return this.httpClient.delete<void>(`${this.BKD_API_URL}/${breakdown.id}`);
  }

  getStatuses(): Observable<string[]> {
    return this.httpClient.get<string[]>(`${this.BKD_API_URL}/statuses`);
  }

  getElements(): Observable<string[]> {
    return this.httpClient.get<string[]>(`${this.BKD_API_URL}/elements`);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/breakdown.service.ts